module.exports = __webpack_public_path__ + "static/img/peekabooman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/peekabooman.jpg
// module id = mmL4
// module chunks = 1